<template>
  <svg width="24" height="24" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32ZM13.6283 13.2575C13.919 12.9671 13.919 12.4442 13.6283 12.0957L10.2559 8.26143C9.96517 7.91286 9.44187 7.91286 9.093 8.26143L7.17424 10.1785C4.49624 12.8542 9.412 17.7615 12.0724 20.4173C12.1269 20.4716 12.1803 20.525 12.2328 20.5774C12.3075 20.6521 12.3844 20.7291 12.4633 20.8081C15.0847 23.4323 19.9295 28.2823 22.5825 25.6317L24.5594 23.6564C24.8501 23.366 24.9083 22.785 24.5594 22.4946L20.6637 19.1832C20.3149 18.8927 19.8497 18.8346 19.5008 19.1832L18.3961 20.2289C17.7565 20.8098 17.3495 20.6355 16.5936 20.0546C15.1982 18.8927 13.8608 17.6146 12.7561 16.1623C12.1747 15.407 11.9421 15.0004 12.5817 14.3613L13.6283 13.2575Z" fill="white"/>
  </svg>
</template>

<script>
export default {
  name: 'phone-icon'
}
</script>
